"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Multiselect = _interopRequireDefault(require("react-widgets/lib/Multiselect"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _admin = require("../../../../selectors/admin.js");
var _InfoLabel = _interopRequireDefault(require("../../../../components/InfoLabel"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var roles = window.cccisd.appDefs.pawn.roles;
var OtherAllowedRoles = function OtherAllowedRoles(_ref) {
  var fields = _ref.fields,
    isNew = _ref.isNew;
  var otherAllowedRoles = fields.otherAllowedRoles,
    respondentConfig = fields.respondentConfig,
    respondentSelection = fields.respondentSelection;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isCollapsed = _useState2[0],
    setIsCollapsed = _useState2[1];
  var projectDeployments = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProjectDeployments)(state.assignment.admin);
  });
  var intendedRoleHandle = currentRoleType();
  var isAnon = respondentConfig.value === 'anonymous';
  var isKnown = respondentConfig.value === 'manual' || intendedRoleHandle === 'respondent' && respondentConfig.value === 'previous';

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE METHODS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    function ensureCurrentRoleNotInList() {
      if (!isNew) {
        return;
      }
      otherAllowedRoles.onChange(otherAllowedRoles.value.filter(function (r) {
        return r !== intendedRoleHandle && r !== 'respondent';
      }));
    }
    ensureCurrentRoleNotInList();
  }, [intendedRoleHandle]);

  /* /////////////////////////////////////////////////////////////////////////
  // GENERAL FUNCTIONS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function currentRoleType() {
    var chosenDeployment = null;
    switch (respondentConfig.value) {
      case 'managed':
        return respondentSelection.value;
      case 'previous':
        chosenDeployment = projectDeployments.find(function (d) {
          return d.deploymentId === Number(respondentSelection.value);
        });
        return chosenDeployment && chosenDeployment.roleHandle || undefined;
      default:
        return 'respondent';
    }
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var renderCollapseArrow = /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_style["default"].collapseArrow, isCollapsed ? _style["default"].collapsed : _style["default"].expanded)
  }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null), ' ');
  var renderCurrentRole = function renderCurrentRole() {
    var intendedRoleIsNumber = !Number.isNaN(Number.parseInt(intendedRoleHandle, 10));
    var selectedRole = roles.find(function (r) {
      return r.handle === intendedRoleHandle;
    });
    var selectedRoleLabel = selectedRole ? selectedRole.label : intendedRoleHandle;
    if (intendedRoleIsNumber) {
      selectedRoleLabel = '';
    } else if (isKnown) {
      selectedRoleLabel = 'Known Respondent';
    } else if (isAnon) {
      selectedRoleLabel = 'Anonymous Respondent';
    }
    var showDropdown = !isKnown && !isAnon;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].fieldSpacing
    }, /*#__PURE__*/_react["default"].createElement("span", {
      onClick: function onClick() {
        return showDropdown && setIsCollapsed(function (prev) {
          return !prev;
        });
      }
    }, showDropdown && renderCollapseArrow, /*#__PURE__*/_react["default"].createElement("span", {
      className: showDropdown ? _style["default"].labelIndent : null
    }, /*#__PURE__*/_react["default"].createElement("strong", null, showDropdown && 'Intended ', "Role:")), ' ', selectedRoleLabel));
  };
  var renderAllowedRolesDropdown = function renderAllowedRolesDropdown() {
    if (isKnown || isCollapsed) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
      field: otherAllowedRoles,
      label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
        label: "Other Allowed Roles",
        optional: true,
        tooltip: "Select any roles that should also be allowed to respond to this Data Collection Wave."
      })
    }, /*#__PURE__*/_react["default"].createElement(_Multiselect["default"], {
      data: roles.filter(function (r) {
        return r.handle !== intendedRoleHandle && r.handle !== 'respondent';
      }),
      onChange: function onChange(e) {
        return otherAllowedRoles.onChange(e.map(function (r) {
          return r.handle;
        }));
      },
      placeholder: "--- Select Other Allowed Roles ---",
      textField: function textField(item) {
        return item && item.label || '';
      },
      value: otherAllowedRoles.value,
      valueField: "handle"
    }));
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, renderCurrentRole(), renderAllowedRolesDropdown());
};
OtherAllowedRoles.propTypes = {
  fields: _propTypes["default"].object,
  isNew: _propTypes["default"].bool
};
var _default = OtherAllowedRoles;
exports["default"] = _default;